import { createRoot } from 'react-dom/client';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { setupInterceptors } from '@api/interceptors';
import App from './App';

// Enable ISO-week math globally. Required by the executive Weekly
// newsletter view, which lets users pick weeks 1..N (Mon–Sun) and
// honours the ISO rollover (e.g. Dec 31 2025 falls in ISO week 1 of
// 2026). Calling this once at bootstrap is safe everywhere else.
dayjs.extend(isoWeek);

setupInterceptors();

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const loader = document.getElementById('root-loader');

const root = createRoot(container);
root.render(<App />);

if (loader) {
  setTimeout(() => {
    loader.style.opacity = '0';
    setTimeout(() => loader.remove(), 300);
  }, 200);
}
